// BEGIN-NOSCAN
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // NOSONAR
// phone regex: only allow numbers, must be 10 digits
export const phoneRegex = /^[\+]?[(]?[\d]{3}[)]?[-\s\.]?[\d]{3}[-\s\.]?[\d]{4,6}$/im // NOSONAR
export const newPhoneRegex = /^[2-9][0-9]{9}$/; // NOSONAR
export const isAliasedEmail = (email: string) => /\+/.test(email);
// END-NOSCAN
